function TopBar() {
  return (
    <div className="hidden md:block border-b border-slate-100 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 py-3 flex justify-between text-xs text-slate-500 font-light">
        <p>Digital solutions for startups, SMEs, and growing companies</p>
        <p>Websites · Branding · UI/UX · Marketing · Automation</p>
      </div>
    </div>
  );
}

export default TopBar;
